import Button from '@/components/elements/forms/buttons/Button/Button';
import BottomSheetModal from '@/components/modules/modals/BottomSheetModal';
import Modal from '@/components/modules/modals/redesign/Modal/Modal';
import { KlarnaVariant } from '@/features/payments/types/adyen.types';
import { KLARNA_BRANDS } from '@/features/payments/utils/paymentConfig.utils';
import useMobileView from '@/hooks/useMobileView';
import { _t } from '@/locale';

function getBrandLabel(brand: KlarnaVariant): string {
  switch (brand) {
    case 'klarna':
      return _t('klarnaPayLater');
    case 'klarna_account':
      return _t('klarnaPayOverTime');
    case 'klarna_paynow':
      return _t('klarnaPaynow');
  }
}

interface KlarnaOptionsModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSelect: (variant: KlarnaVariant) => void;
  brands: KlarnaVariant[];
}

const KlarnaOptionsModal = ({ isOpen, onClose, onSelect, brands }: KlarnaOptionsModalProps) => {
  const { isMobileView } = useMobileView();
  const validBrands = brands.filter((b) => KLARNA_BRANDS.includes(b));

  const content = (
    <div className="gap-xxl p-3xl flex flex-col items-center">
      <img src="/images/logos/klarna-logo.svg" alt="Klarna" style={{ height: '61px', width: 'auto' }} />
      <div className="gap-sm flex flex-col items-center text-center">
        <h2 className="text-h-m font-bold">{_t('klarnaHowToPayTitle')}</h2>
        <p className="text-fg_secondary text-l">{_t('klarnaRedirectDescription')}</p>
      </div>
      <div className="gap-md flex w-full flex-col">
        {validBrands.map((brand) => (
          <Button
            key={brand}
            variant="primary"
            size="lg"
            block
            label={getBrandLabel(brand)}
            onClick={() => onSelect(brand)}
          />
        ))}
      </div>
    </div>
  );

  if (isMobileView) {
    return (
      <BottomSheetModal isOpen={isOpen} onClose={onClose} title={_t('klarnaBottomSheetTitle')}>
        {content}
      </BottomSheetModal>
    );
  }

  return (
    <Modal isOpen={isOpen} onRequestClose={onClose}>
      <Modal.Content newDesign={true} contentPadding={false} floating={true} contentMaxWidth={500}>
        <Modal.Header newDesign={true} floating={true} onClose={onClose} title={_t('klarnaBottomSheetTitle')} />
        {content}
      </Modal.Content>
    </Modal>
  );
};

export default KlarnaOptionsModal;
